import React from 'react'
import { Box, IconButton, MenuItem, Select, Typography } from '@mui/material'
import { Refresh } from '@mui/icons-material'
import PropTypes from 'prop-types'

export default function AdminSeatHeader({ shows, showId, scheduleId, onShowChange, onScheduleChange, onRefresh, refreshing }) {
  const selectedShow = shows.find((s) => s.id === showId)

  return (
    <Box sx={{ zIndex: 1 }}>
      <Select id='select-show' value={showId} label='Spectacle' onChange={(event) => onShowChange(event.target.value)} variant='standard'>
        {shows.map((show) => (
          <MenuItem key={show.id} value={show.id}>
            {show.title}
          </MenuItem>
        ))}
      </Select>
      <Select
        variant='standard'
        id='select-schedule'
        value={scheduleId}
        sx={{ ml: 2, mb: 2 }}
        label='Horaire'
        onChange={(event) => onScheduleChange(event.target.value)}
        disabled={!showId}
      >
        {selectedShow?.schedules.map((schedule) => (
          <MenuItem key={schedule.id} value={schedule.id}>
            {schedule.date} - {schedule.time}
          </MenuItem>
        ))}
      </Select>

      {showId && scheduleId && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, width: '100%' }}>
          <IconButton size='small' onClick={onRefresh} disabled={refreshing} sx={{ color: 'title.main' }}>
            <Refresh
              sx={{
                fontSize: 24,
                animation: refreshing ? 'spin 1s linear infinite' : 'none',
                '@keyframes spin': { from: { transform: 'rotate(0deg)' }, to: { transform: 'rotate(360deg)' } }
              }}
            />
          </IconButton>
          <Typography variant='h5' sx={{ mb: 1, fontWeight: 'bold', color: 'title.main' }}>
            Administration - Plan de la salle
          </Typography>
        </div>
      )}
    </Box>
  )
}
AdminSeatHeader.propTypes = {
  shows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.string,
      price: PropTypes.number,
      schedules: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
          date: PropTypes.string.isRequired,
          time: PropTypes.string.isRequired
        })
      ).isRequired
    })
  ).isRequired,
  showId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  scheduleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onShowChange: PropTypes.func.isRequired,
  onScheduleChange: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  refreshing: PropTypes.bool.isRequired
}
